export enum ShopChannelType {
  ShopE3dc = 'e3dc',
  ShopInternalCh = 'InternalCH',
  ShopInternalNL = 'IntenralNL',
  ShopInternalFlow = 'InternalFlow',
}
export interface ShopChannelDefaultRules {
  allowSmartMeter: boolean
  allowPowerMeter: boolean
  requireRetrofitBatterySerialNumber: boolean
  allowInputFieldOnProductQuantity: boolean
}

/** This constant contains default rules for the shop */
export const SHOP_CHANNEL_DEFAULT_RULES: ShopChannelDefaultRules = {
  allowSmartMeter: true,
  allowPowerMeter: true,
  requireRetrofitBatterySerialNumber: true,
  allowInputFieldOnProductQuantity: true,
}

/** This constant returns set rules based on the shop channel */
export const SHOP_CHANNEL_RULES_TYPE: Record<ShopChannelType, ShopChannelDefaultRules> = {
  [ShopChannelType.ShopE3dc]: { ...SHOP_CHANNEL_DEFAULT_RULES },
  [ShopChannelType.ShopInternalCh]: {
    allowSmartMeter: false,
    allowPowerMeter: false,
    requireRetrofitBatterySerialNumber: false,
    allowInputFieldOnProductQuantity: true,
  },
  [ShopChannelType.ShopInternalFlow]: {
    allowSmartMeter: false,
    allowPowerMeter: false,
    requireRetrofitBatterySerialNumber: false,
    allowInputFieldOnProductQuantity: true,
  },
  [ShopChannelType.ShopInternalNL]: {
    allowSmartMeter: false,
    allowPowerMeter: true,
    requireRetrofitBatterySerialNumber: false,
    allowInputFieldOnProductQuantity: true,
  },
}
